<ion-row>
  <ion-col>
    <ion-text color="primary">{{field.name}}</ion-text>
    <ion-row>
      <span>
        <ion-icon class="small_icons" color="primary" name="assignment-ind"></ion-icon>
      </span>
      <span *ngIf="field.customer">
        <ion-text>{{field.customer.name}}</ion-text>
      </span>
    </ion-row>
    <ion-row>
      <span >
        <ion-icon class="small_icons" color="primary"  name="apps-sharp"></ion-icon>
      </span>
      <span>
        <ion-text>{{field.geometry.area}} ha</ion-text>
      </span>
    </ion-row>
    <ion-row>
      <span>
        <ion-icon class="small_icons" color="primary" name="chatbox-ellipses-outline"></ion-icon>
      </span>
      <span>
        <ion-text>{{field.comment}}</ion-text>
      </span>
    </ion-row>
  </ion-col>

  <ion-col class="nav-button">
    <ion-row>
      <ion-fab-button style="transform: scale(0.6);" size="small" (click)="navigateToField()">
        <ion-icon name="navigate-outline" class="icon-button inner-center-btn"></ion-icon>
      </ion-fab-button>
    </ion-row>
  </ion-col>
</ion-row>
